import { z } from "zod";

// Chat request schema
export const chatRequestSchema = z.object({
  message: z.string().min(1, "Message is required").optional(),
  messages: z
    .array(
      z.object({
        role: z.enum(["user", "assistant"]),
        content: z.string(),
      })
    )
    .optional(),
  chatId: z.string().optional().nullable(),
  type: z.enum(["general", "homework", "research"]).default("general"),
});

// Homework request schema
export const homeworkRequestSchema = z.object({
  subject: z
    .string()
    .min(1, { message: "Subject is required." })
    .max(100, { message: "Subject must not exceed 100 characters." }),
  problem: z
    .string()
    .min(10, { message: "Problem description must be at least 10 characters." })
    .max(2000, {
      message: "Problem description must not exceed 2000 characters.",
    })
    .optional(),
  class: z
    .string()
    .max(50, { message: "Class must not exceed 50 characters." })
    .optional(),
  chapter: z
    .string()
    .max(100, { message: "Chapter must not exceed 100 characters." })
    .optional(),
  difficulty: z.enum(["beginner", "intermediate", "advanced"]).optional(),
});

// Research request schema
export const researchRequestSchema = z.object({
  topic: z
    .string()
    .min(3, { message: "Topic must be at least 3 characters." })
    .max(200, { message: "Topic must not exceed 200 characters." }),
  depth: z.enum(["basic", "intermediate", "advanced"]).default("intermediate"),
  focus: z
    .enum(["overview", "analysis", "comparison", "timeline", "examples"])
    .optional(),
  sources: z.enum(["academic", "general", "news", "mixed"]).default("mixed"),
});

// Export TypeScript types
export type ChatRequestValues = z.infer<typeof chatRequestSchema>;
export type HomeworkRequestValues = z.infer<typeof homeworkRequestSchema>;
export type ResearchRequestValues = z.infer<typeof researchRequestSchema>;

// Export all AI schemas as a collection
export const aiSchemas = {
  chat: chatRequestSchema,
  homework: homeworkRequestSchema,
  research: researchRequestSchema,
} as const;
